import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  div.content {
    flex: 1;
  }
`;
